import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetDate, GetTime } from '../../../app/AppUtils';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelMoments({ disabled, jsonData, fileName }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);

    useEffect(() => {
        if (jsonData) {
            let data = jsonData.map(({ id, ...rest }) => rest);

            // Header row
            setExcelHeaderRow([
                `${resourceFinal[appLanguage].words.ACTIVITY}${resourceFinal[appLanguage].words.NAME.toLowerCase()}`,
                `${resourceFinal[appLanguage].words.PERFORMANCE}${resourceFinal[appLanguage].words.NAME.toLowerCase()}`,
                `${resourceFinal[appLanguage].words.PERFORMANCE}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                `${resourceFinal[appLanguage].words.START}${resourceFinal[appLanguage].words.TIME.toLowerCase()}`,
                `${resourceFinal[appLanguage].words.END}${resourceFinal[appLanguage].words.TIME.toLowerCase()}`,
                resourceFinal[appLanguage].words.LOCATION,
                resourceFinal[appLanguage].words.SUBSCRIPTIONS,
                resourceFinal[appLanguage].words.CAPACITY,
            ]);

            // Data rows
            let dataRows = [];

            data?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (key.toLowerCase().includes("date") || key.toLowerCase().includes("time")) {
                            return value === null ? "" : `${GetDate(value)} (${GetTime(value)})`;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={fileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />
    );
}
